import React from 'react';
const DEFAULT_RADAR_RADIUS = 3000; // meters.
const MonitorMapContext = React.createContext({
    vehicles: undefined,
    setVehicles: undefined,
    radarRadius: DEFAULT_RADAR_RADIUS,
    setRadarRadius: undefined,
    selectedVehicleId: undefined,
    setSelectedVehicleId: undefined,
    showFootprint: true,
    setShowFootprint: undefined,
    showRadar: true,
    setShowRadar: undefined,
    showFlightPath: true,
    setShowFlightPath: undefined,
    showGeoFence: true,
    setShowGeoFence: undefined,
    showSafePort: true,
    setShowSafePort: undefined,
    showNoFlyZone: true,
    setShowNoFlyZone: undefined,
});
function MonitorMapProvider({ children }) {
    const [vehicles, setVehicles] = React.useState();
    const [radarRadius, setRadarRadius] = React.useState(DEFAULT_RADAR_RADIUS);
    const [selectedVehicleId, setSelectedVehicleId] = React.useState();
    const [showFootprint, setShowFootprint] = React.useState(true);
    const [showRadar, setShowRadar] = React.useState(true);
    const [showFlightPath, setShowFlightPath] = React.useState(true);
    const [showGeoFence, setShowGeoFence] = React.useState(true);
    const [showSafePort, setShowSafePort] = React.useState(true);
    const [showNoFlyZone, setShowNoFlyZone] = React.useState(true);
    const provided = {
        vehicles,
        setVehicles,
        radarRadius,
        setRadarRadius,
        selectedVehicleId,
        setSelectedVehicleId,
        showFootprint,
        setShowFootprint,
        showRadar,
        setShowRadar,
        showFlightPath,
        setShowFlightPath,
        showGeoFence,
        setShowGeoFence,
        showSafePort,
        setShowSafePort,
        showNoFlyZone,
        setShowNoFlyZone,
    };
    return React.createElement(MonitorMapContext.Provider, { value: provided }, children);
}
export { MonitorMapContext, MonitorMapProvider };
